import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import GoldenBallIcon from "../../assets/img/golden-ball.png";
import GoldenBootIcon from "../../assets/img/golden-boot.png";
import GoldenGloveIcon from "../../assets/img/golden-glove.png";

// The real general_questions API has no per-question category (no more
// golden_ball/golden_boot/golden_glove question_key), so the icon/accent
// is picked by matching keywords in the question text itself instead.
const AWARD_KEYWORDS = [
  // golden-glove.png is a flat black silhouette (unlike the ball/boot
  // artwork, which is already full-color) — `tinted` marks it to be
  // rendered as a gold-masked shape instead of the raw PNG colors.
  { match: /glove/i, image: GoldenGloveIcon, accent: "#22d0ba", tinted: true },
  { match: /boot/i, image: GoldenBootIcon, accent: "#ff9f1c" },
  { match: /ball/i, image: GoldenBallIcon, accent: "#ffcc00" },
];

// Fallback for questions that don't match ball/boot/glove — no custom
// image for this case, so it renders via the `Icon` component instead.
const DEFAULT_THEME = { image: null, Icon: EmojiEventsIcon, accent: "#ffcc00", tinted: false };

export const getAwardTheme = (questionText = "") => {
  const found = AWARD_KEYWORDS.find(({ match }) => match.test(questionText));
  return found
    ? { image: found.image, Icon: null, accent: found.accent, tinted: !!found.tinted }
    : DEFAULT_THEME;
};
